"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFilterGroup = exports.isNullValueFilterPartType = exports.LogicalOperatorType = exports.isComparisonType = exports.ComparisonType = exports.isExpressionFunctionType = exports.ExpressionFunctionType = void 0;
var ExpressionFunctionType;
(function (ExpressionFunctionType) {
    ExpressionFunctionType["BEGINS_WITH"] = "begins_with";
    ExpressionFunctionType["CONTAINS"] = "contains";
    ExpressionFunctionType["NOT_CONTAINS"] = "not contains";
    ExpressionFunctionType["NOT_BEGINS_WITH"] = "not begins_with";
    ExpressionFunctionType["EXISTS"] = "attribute_exists";
    ExpressionFunctionType["NOT_EXISTS"] = "attribute_not_exists";
})(ExpressionFunctionType || (exports.ExpressionFunctionType = ExpressionFunctionType = {}));
const isExpressionFunctionType = (possibleEnumValue) => Object.values(ExpressionFunctionType).includes(possibleEnumValue);
exports.isExpressionFunctionType = isExpressionFunctionType;
var ComparisonType;
(function (ComparisonType) {
    ComparisonType["EQUALS"] = "=";
    ComparisonType["NOT_EQUALS"] = "<>";
    ComparisonType["LESS_THAN"] = "<";
    ComparisonType["LESS_EQUAL"] = "<=";
    ComparisonType["GREATER_THAN"] = ">";
    ComparisonType["GREATER_EQUAL"] = ">=";
})(ComparisonType || (exports.ComparisonType = ComparisonType = {}));
const isComparisonType = (possibleEnumValue) => Object.values(ComparisonType).includes(possibleEnumValue);
exports.isComparisonType = isComparisonType;
var LogicalOperatorType;
(function (LogicalOperatorType) {
    LogicalOperatorType["AND"] = "and";
    LogicalOperatorType["OR"] = "or";
})(LogicalOperatorType || (exports.LogicalOperatorType = LogicalOperatorType = {}));
const NULL_VALUE_PREDICATES = [ExpressionFunctionType.EXISTS, ExpressionFunctionType.NOT_EXISTS];
const isNullValueFilterPartType = (filterPartType) => NULL_VALUE_PREDICATES.includes(filterPartType.predicate);
exports.isNullValueFilterPartType = isNullValueFilterPartType;
const isFilterPartType = (x) => {
    const y = x;
    const requiredKeys = ['key', 'predicate'];
    const yKeys = Object.keys(y);
    return requiredKeys.every((k) => yKeys.includes(k));
};
const isFilterGroup = (x) => {
    const y = x;
    const hasSetOperation = [LogicalOperatorType.AND, LogicalOperatorType.OR].includes(y.setOperation);
    const hasValidFilterParts = y.filters.every(isFilterPartType);
    return hasSetOperation && hasValidFilterParts;
};
exports.isFilterGroup = isFilterGroup;
